// extracted by mini-css-extract-plugin
export default {"fieldGroupPlain":"DiscountFilter_fieldGroupPlain__+Yr2b"};